import { AbstractModel } from '../models/abstract.model';
import { IsString, IsDate, IsNumber } from 'class-validator';
import { AssetInterface } from './asset.interface';
import { Type } from 'class-transformer';


export class AssetStateModel {
    @IsString()
    public value: string = 'ok';

    @IsString()
    public icon: string = 'error';

    @IsString()
    public color: string = 'green';

    @IsString()
    public name: string = 'Ok';
}

export const assetStates: AssetStateModel[] = [
    { value: 'undefined', icon: 'indeterminate_check_box', color: '#3f51b5', name: 'Undefined' },
    { value: 'ok', icon: 'check_circle', color: '#46982b', name: 'Ok' },
    { value: 'malfunction', icon: 'warning', color: '#ffdc00', name: 'Malfunction' },
    { value: 'lost', icon: 'error', color: '#ff3b00', name: 'Lost' },
    { value: 'endOfLife', icon: 'error', color: '#ff3b00', name: 'End of Life' },
];


export class AssetModel extends AbstractModel implements AssetInterface {

    @IsString()
    public title: string = '';

    @IsString()
    public description: string = '';

    @IsString()
    public hint: string = '';

    @IsString()
    public manufacturer: string = '';

    @IsString()
    public _placeId: number = 0;

    @IsString()
    public room: string = '';

    @IsString()
    public state: string = 'ok';

    @IsNumber()
    public _classId: number = 0;

    @Type(() => Date)
    @IsDate()
    aquisitionDate: Date = new Date();

    @IsNumber()
    aquisitionValue: number = 0;

    getState(): AssetStateModel {
        const state =  assetStates.find((element) => {
            return element.value === this.state;
        });
        if(state) {
            return state;
        } else {
            return assetStates[0];
        }
    }

    setState(state: AssetStateModel): void {
        this.state = state.value;
    }
}
